/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.unspecced.getConfig'

export { $nsid }

/** Get miscellaneous runtime configuration. */
const main = l.query(
  $nsid,
  l.params(),
  l.jsonPayload({
    checkEmailConfirmed: l.optional(l.boolean()),
    liveNow: l.optional(
      l.array(l.ref<LiveNowConfig>((() => liveNowConfig) as any)),
    ),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type LiveNowConfig = {
  $type?: 'app.bsky.unspecced.getConfig#liveNowConfig'
  did: l.DidString
  domains: string[]
}

export type { LiveNowConfig }

const liveNowConfig = l.typedObject<LiveNowConfig>(
  $nsid,
  'liveNowConfig',
  l.object({ did: l.string({ format: 'did' }), domains: l.array(l.string()) }),
)

export { liveNowConfig }
